
import React, {Component} from 'react'
import humanizeDuration from "humanize-duration";

const salesStatusUtil = require('../../utils/domain/sales/salesStatusUtil');
const businessDateUtil = require('../../utils/dateUtil/businessDateUtil');
const dateUtil = require('../../utils/dateUtil/dateUtil');
const translator = require('../../utils/translator/translator');
const stringUtil = require('../../utils/string/stringUtil');
const saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility');

class SaleTimeComponent extends Component 
{
    render()
    {
        let sale = this.props.sale;

        if (saleCommonUtility.isCancelled(sale) || saleCommonUtility.isSaleHoldByStaff(sale))
            return this.getPlainSateTimeComponent();

        if (dateUtil.isSame(businessDateUtil.getTodayBusinessDate(), businessDateUtil.getPropertyBusinessDateFromUtcDateTime(sale.dateTime)))
            return this.getTodaysSaleTimeComponent();

        return this.getPastSaleTimeComponent();
    }

    getTodaysSaleTimeComponent()
    {
        let sale = this.props.sale;

        if (!salesStatusUtil.isSaleCompletedByAnyFinalStation(sale.id))
            return this.getTodaysSaleTimeComponentWhenSaleInProcess();

        if (!salesStatusUtil.isSaleCompletedByDispatchStation(sale.id))
            return this.getTodaysSaleTimeComponentWhenSaleIsReadyButNotDispatched();

        return this.getTodaysSaleTimeComponentWhenSaleIsDispatched();
    }

    getTodaysSaleTimeComponentWhenSaleInProcess()
    {
        let sale = this.props.sale;
        
        if (dateUtil.isBefore(dateUtil.getNow(), sale.dueDateTime))
        {
            var differenceInMilliseconds = dateUtil.differenceInMilliseconds(sale.dueDateTime, dateUtil.getNow());
            var caption = humanizeDuration(differenceInMilliseconds, {delimiter: " and ", units: ['h', 'm'], round: true});

            return <div className='d-flex' 
                                style={{background:'green', color:'white', 
                                        paddingTop:'5px', paddingBottom:'5px', 
                                        paddingRight:'10px', paddingLeft:'10px',
                                        borderRadius:'25px'}}>
                        <div style={{marginRight:'5px'}}>{translator.getLabel("due_in")}</div>
                        <div>{caption}</div>
                    </div>
        }



        var differenceInMilliseconds = dateUtil.differenceInMilliseconds(dateUtil.getNow(), sale.dueDateTime);
        var caption = humanizeDuration(differenceInMilliseconds, {delimiter: " and ", units: ['h', 'm'], round: true});

        return <div className='d-flex' 
                                style={{background:'red', color:'white', 
                                        paddingTop:'5px', paddingBottom:'5px', 
                                        paddingRight:'10px', paddingLeft:'10px',
                                        borderRadius:'25px'}}>
                        <div style={{marginRight:'5px'}}>{translator.getLabel("overdue_by")}</div>
                        <div>{caption}</div>
                    </div>
    }

    getTodaysSaleTimeComponentWhenSaleIsReadyButNotDispatched()
    {
        let sale = this.props.sale;
        let readySince = "N/A";

        if (!stringUtil.isStringNullOrEmpty(sale.finalStationCompletionDateTime))
        {
            var differenceInMilliseconds = dateUtil.differenceInMilliseconds(dateUtil.getNow(), sale.finalStationCompletionDateTime);
            readySince = humanizeDuration(differenceInMilliseconds, {delimiter: " and ", units: ['h', 'm'], round: true});
        }

        return <div className='d-flex' 
                                style={{background:'#F97B22', color:'white', 
                                        paddingTop:'5px', paddingBottom:'5px', 
                                        paddingRight:'10px', paddingLeft:'10px',
                                        borderRadius:'25px'}}>
                        <div style={{marginRight:'5px'}}>{translator.getLabel("ready_since")}</div>
                        <div>{readySince}</div>
                    </div>
    }

    getTodaysSaleTimeComponentWhenSaleIsDispatched()
    {
        return this.getPastSaleTimeComponent();
    }


    getPastSaleTimeComponent()
    {
        let sale = this.props.sale;

        let kitchenPrepTime = "N/A";
        if (!stringUtil.isStringNullOrEmpty(sale.finalStationCompletionDateTime))
            kitchenPrepTime = dateUtil.formatDate(dateUtil.convertToLocalStandard(sale.finalStationCompletionDateTime), "DD MMM HH:mm");
        
        let actualDispatchDateTime = "N/A";
        if (!stringUtil.isStringNullOrEmpty(sale.actualDispatchDateTime))
            actualDispatchDateTime = dateUtil.formatDate(dateUtil.convertToLocalStandard(sale.actualDispatchDateTime), "DD MMM HH:mm");
        
        

        return <div>
                    <div className='d-flex justify-content-center'>
                        <div style={{marginRight:'5px'}}>{translator.getLabel("sale_time")}</div>
                        <div>{dateUtil.formatDate(dateUtil.convertToLocalStandard(sale.dateTime), "DD MMM HH:mm")}</div>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <div style={{marginRight:'5px'}}>{translator.getLabel("prep_time")}</div>
                        <div>{kitchenPrepTime}</div>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <div style={{marginRight:'5px'}}>{translator.getLabel("dispatch_time")}</div>
                        <div>{actualDispatchDateTime}</div>
                    </div>
                </div>
    }

    getPlainSateTimeComponent()
    {
        let sale = this.props.sale;
        
        return <div>
                    <div className='d-flex justify-content-center'>
                        <div style={{marginRight:'5px'}}>{translator.getLabel("sale_time")}</div>
                        <div>{dateUtil.formatDate(dateUtil.convertToLocalStandard(sale.dateTime), "DD MMM HH:mm")}</div>
                    </div>
                </div>
    }
}

export default SaleTimeComponent